import MentoringProgramCard from './MentoringProgramCard.vue';

export * from './components';
export * from './types';
export default MentoringProgramCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/index.ts